import Link from 'next/link';
import styled from 'styled-components';

import { Futura } from '~/styles';
import { media } from '~/utils';

import LogoImage from '@public/images/logo.svg';

export const Footer = () => {
  return (
    <Wrapper>
      <Left>
        <LogoImage color='white' />
        <Text>
          誰もが、より良い社会の為に
          <br />
          つながれて支え合える世界を目指し、
          <br />
          社会構造のアップデートに挑戦します。
        </Text>
      </Left>
      <Center>
        <CenterItem>
          <CenterItemLeft>PROJECTS</CenterItemLeft>
          <CenterItemRight>プロジェクト</CenterItemRight>
        </CenterItem>
        <CenterItem>
          <CenterItemLeft>SPO</CenterItemLeft>
          <CenterItemRight>課題解決の実践者</CenterItemRight>
        </CenterItem>
        <CenterItem>
          <CenterItemLeft>CORPORATES</CenterItemLeft>
          <CenterItemRight>社会との共生を目指す企業</CenterItemRight>
        </CenterItem>
        <CenterItem>
          <CenterItemLeft>REPORTS</CenterItemLeft>
          <CenterItemRight>わくわくレポート</CenterItemRight>
        </CenterItem>
      </Center>
      <Right>
        <RightLabel>
          <Menu>MENU</Menu>
          <span>社会課題へのアプローチ</span>
        </RightLabel>
        <Competitions href='/about'>わくわく寄付コンペ</Competitions>
        <Furusato href='/about-corp-furusato'>企業版ふるさと納税</Furusato>
        <RightLinks>
          <a href='/terms' target='_blank'>
            利用規約
          </a>
          <a href='/privacy' target='_blank'>
            プライバシーポリシー
          </a>
          <a href='https://www.ichicommons.com' rel='noopener noreferrer' target='_blank'>
            運営会社
          </a>
        </RightLinks>
      </Right>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.div`
  padding: 100px 0;
  width: 100%;
  background: #262626;
  display: flex;
  flex-direction: row;
  justify-content: center;

  ${media.mid`
    flex-direction: column;
    align-items: center;
  `}
`;

const Left = styled.div`
  width: 270px;

  ${media.mid`
    width: 320px;
  `}
`;

const Text = styled.div`
  margin-top: 25px;
  font-size: 13px;
  line-height: 22px;
  color: #fff;
  letter-spacing: 1px;
`;

const Center = styled.div`
  margin-left: 40px;
  width: 320px;

  ${media.mid`
    margin-top: 15px;
    margin-left: 0;
  `}
`;

const CenterItem = styled.div`
  margin-top: 7px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #c4c4c4;

  &:first-child {
    margin-top: 0;
  }
`;

const CenterItemLeft = styled(Futura)`
  font-style: italic;
  font-size: 16px;
  color: #fff;
  letter-spacing: 1px;
`;

const CenterItemRight = styled.div`
  font-size: 12px;
  color: #c4c4c4;
  letter-spacing: 1px;
`;

const Right = styled.div`
  margin-left: 20px;
  width: 320px;

  ${media.mid`
    margin-top: 10px;
    margin-left: 0;
  `}
`;

const RightLabel = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;

  & > span {
    font-size: 12px;
    color: #c4c4c4;
  }
`;

const Menu = styled(Futura)`
  font-style: italic;
  font-size: 16px;
  color: #fff;
  letter-spacing: 1px;
`;

const Competitions = styled(Link)`
  display: block;
  margin-top: 5px;
  padding-left: 18px;
  height: 30px;
  line-height: 30px;
  background: #ceab19;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 1px;
`;

const Furusato = styled(Competitions)`
  background: #ff346b;
  letter-spacing: 1px;
`;

const RightLinks = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & > a {
    color: #c4c4c4;
    text-decoration: underline;
    font-size: 12px;
    font-weight: bold;
  }
`;
